<div class="card">
    <h4 *ngIf="isShipmentPendingMap"><strong>Pending Schedule</strong></h4>
    <h4 *ngIf="isShipmentCreatedMap"><strong>Shipped Schedule</strong></h4>
    <div class="card" style="display: flex; justify-content:end; padding:0%; align-items:center; border: none; background-color: transparent;">
        <div class="grid">
        <p-button  label="Pending Schedule" (click)="shipmentPendingAndCreated(1)" severity="warning" class="mr-2"/>
        <p-button  label="Shipped Schedule" (click)="shipmentPendingAndCreated(2)" severity="success" class="mr-2"/>
        <!-- <button pButton type="button"  style="height:10px; margin-right: 10px; margin-top: -10px; background-color:#2c436b" ></button>    -->
        <!-- <p-button label="Report" icon="pi pi-download" (click)="downloadExcel()"/>  -->
        </div>
    </div>
    <hr>
    <div *ngIf="isContentVisible">
        <!-- <div class="flex flex-wrap gap-0">
            <div class="flex flex-wrap gap-1 mb-3">
                <div class="flex-auto">
                    <label for="integer" class="font-bold block mb-2">Company Code</label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="companyCode" placeholder="Company Code"
                            pKeyFilter="alpha" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="number" class="font-bold block mb-2">Plant</label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="plant" placeholder="Plant " pKeyFilter="Plant"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="money" class="font-bold block mb-2"> Doc.Type </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docType" placeholder="Doc.Type"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="money" class="font-bold block mb-2"> Doc.Cat </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docCat" placeholder="Doc.Cat"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="hex" class="font-bold block mb-2"> PO/Agreement No </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="poAgreementNo" placeholder="PO/Agreement No"
                            pKeyFilter="PO/Agreement No" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphabetic" class="font-bold block mb-2"> Vendor Code </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="vendorCode" placeholder="Vendor Code"
                            pKeyFilter="Vendor Code" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphanumeric" class="font-bold block mb-2"> Status </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="status" placeholder="Status"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="hex" class="font-bold block mb-2"> Document Date </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [iconDisplay]="'input'" [(ngModel)]="documentDate" [showIcon]="true"
                            placeholder="Document Date" class="custom-calendar-filter"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphabetic" class="font-bold block mb-2 pl-5">Delivery Date</label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [iconDisplay]="'input'" [showIcon]="true" placeholder="Delivery Date"
                            [(ngModel)]="deliveryDate" class="custom-calendar-filter pl-5"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2 pl-5 mt-2">
                <div class="flex-auto">
                    <p-button class="flex justify-content-end" icon="pi pi-search" (click)="filterScheduleData()"
                        label="search" pAutoFocus [autofocus]="true"></p-button>
                </div>
            </div>
        </div> -->

        <div class="col-12 md:col-12">
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Company Code</label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="companyCode" pKeyFilter="alpha"
                            class="w-full text-sm py-1" />
                    </div>

                </div>
                <div class="field col">
                    <label>Plant</label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="plant" pKeyFilter="Plant"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Doc.Type </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docType" pKeyFilter="Doc.Type"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Doc.Cat </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docCat" pKeyFilter="Doc.Type"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> PO/Agreement No </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="poAgreementNo" pKeyFilter="PO/Agreement No"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
            </div>

            <div class="p-formgrid grid">
                <div class="field col">
                    <label> Vendor Code </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="vendorCode" pKeyFilter="Vendor Code"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Status </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="status" class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Document Date </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [iconDisplay]="'input'" [(ngModel)]="documentDate" [showIcon]="true"
                            class="custom-calendar-filter" placeholder="Global Search"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
                <div class="field col">
                    <label> </label>
                    <p-button class="flex " icon="pi pi-search" (click)="filterScheduleData()" label="search" pAutoFocus
                        [autofocus]="true" [ngStyle]="{'height.px': '30'}"></p-button>
                </div>
                <div class="field col">
                </div>
            </div>
        </div>
    </div>

    <div style="margin-bottom: 10px;"></div>
    <!-- <div class="content-toggle-aero">
        <button (click)="toggleContentVisibility()" class="content-toggle-button">
            <i class="pi" [ngClass]="isContentVisible ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
        </button>
        <div class="line"></div>
    </div> -->
    <div style="margin-bottom: 10px;"></div>

    <p-treeTable #tt *ngIf="isShipmentPendingMap" [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols"
        [scrollable]="true"
        [tableStyle]="{ 'min-width': '110rem','min-height':'10px' }">
        <ng-template pTemplate="header" let-columns >
            <tr>
                <th class="text-center">
                    <button type="button" [disabled]="selectedRows.length === 0" (click)="addToShipment()"
                        class="p-button p-button-primary" style="height: 10px; width: 80px;">Process</button>
                    &nbsp; &nbsp;&nbsp;
                </th>
                <th class="text-center">Vendor Code </th>
                <th class="text-center">Status</th>
                <th class="text-center">Item No</th>
                <th class="text-center">PO/Agreement No</th>
                <th class="text-center">Material Code</th>
                <th class="text-center">Description </th>
                <th class="text-center">Delivery Date</th>
                <th class="text-center">Open Quantity</th>
                <th class="text-center">UOM</th>
                <!-- <th class="text-center">Vendor Name</th> -->

            </tr>
            <tr>
                <th *ngFor="let col of cols">
                    <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)"
                        [ngModel]="col.defaultFilter" /> -->
                        <ng-container *ngIf="col.field === 'delivery_date'; else textInput">
                          <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                        </ng-container>
                        <ng-template #textInput>
                          <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                        </ng-template>
                </th>
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="caption">
            <div class="flex justify-content-end align-items-center">
                <div class="p-input-icon-left">
                    <i class="pi pi-search" style="font-size: 12px;"></i>
                    <input type="text" class="global-search" pInputText placeholder="Global Search"
                        (input)="onGlobalSearch($event)" />
                </div>
            </div>
        </ng-template> -->
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode">
                <td *ngFor="let col of columns; let i = index">
                    <ng-container *ngIf="setButton(rowNode)">
                        <p-checkbox *ngIf="i === 0" #checkbox [binary]="true" [disabled]="isItemNoInList(rowData)"
                            (onChange)="onCheckboxChange($event, rowData)"
                            [ngModel]="rowData.checked" class="custom-checkbox"></p-checkbox>
                    </ng-container>
                    <div *ngIf="col.field === 'status'; else defaultField">
                        <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))">
                            {{ rowData[col.field] }}
                        </span>
                    </div>

                    <ng-template #defaultField>
                        {{ rowData[col.field] }}
                    </ng-template>
                    <!-- {{ rowData[col.field] }} -->
                </td>
            </tr>
        </ng-template>
    </p-treeTable>


    <p-treeTable *ngIf="isShipmentCreatedMap" #tt [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols1"
       [scrollable]="true"
        [tableStyle]="{ 'min-width': '110rem','min-height':'10px' }" >
        <ng-template pTemplate="header" let-columns >
            <tr>
                <!-- <th class="text-center">
                    <button type="button" [disabled]="selectedRows.length === 0" (click)="addToShipment()"
                        class="p-button p-button-primary" style="height: 10px; width: 80px;">Process</button>
                    &nbsp; &nbsp;&nbsp;
                </th> -->
                <th class="text-center">Vendor Code </th>
                <th class="text-center">Status</th>
                <th class="text-center">Item No</th>
                <th class="text-center">PO/Agreement No</th>
                <th class="text-center">Material Code</th>
                <th class="text-center">Description </th>
                <th class="text-center">Delivery Date</th>
                <th class="text-center">Open Quantity</th>
                <th class="text-center">UOM</th>
                <!-- <th class="text-center">Vendor Name</th> -->

            </tr>
            <tr>
                <th *ngFor="let col of cols1">
                    <!-- <input pInputText type="text" (input)="onInputChange($event, col.field)"
                        [ngModel]="col.defaultFilter" /> -->
                        <ng-container *ngIf="col.field === 'delivery_date'; else textInput">
                          <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                        </ng-container>
                        <ng-template #textInput>
                          <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                        </ng-template>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode">
                <td *ngFor="let col of columns; let i = index">
                    <div *ngIf="col.field === 'status'; else defaultField">
                        <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))">
                            {{ rowData[col.field] }}
                        </span>
                    </div>

                    <ng-template #defaultField>
                        {{ rowData[col.field] }}
                    </ng-template>
                    <!-- {{ rowData[col.field] }} -->
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
    <div>
        <p-paginator
        [rows]="limit"
        [first]="(currentPage - 1) * limit"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[10, 20,30,50,100]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          />
    </div>

<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{'width': '70%'}">
    <div class="row">
        <div class="column">
            <h5><strong>{{"PO/Agreement No : "+ po_no}}</strong></h5>
        </div>
    </div> <br>
    <p-table #dt [value]="selectedPOData" styleClass="p-datatable-sm" selectionMode="multiple">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>Plant</th>
                <th>PO/Agreement No</th>
                <th>Document Date</th>
                <th>Vendor Code</th>
                <th>Name</th>
                <th>Status</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{rowData.itemNo}}</td>
                <td>{{rowData.plant}}</td>
                <td>{{rowData.pono}}</td>
                <td>{{rowData.ddate}}</td>
                <td>{{rowData.vcode}}</td>
                <td>{{rowData.name}}</td>
                <td></td>
            </tr>
        </ng-template>
    </p-table>
    <h5><strong>Schedule List</strong></h5><br>
    <p-table #dt [value]="selectedPOScheduleData" styleClass="p-datatable-sm" selectionMode="multiple"> <ng-template
            pTemplate="header" let-columns>
            <tr>
                <th>Item No</th>
                <th>Material Code</th>
                <th>Description </th>
                <th>Delivery Date</th>
                <th>Quantity</th>
                <th>UOM</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{rowData.itemNo}}</td>
                <td>{{rowData.plant}}</td>
                <td>{{rowData.pono}}</td>
                <td>{{rowData.ddate}}</td>
                <td>{{rowData.vcode}}</td>
                <td>{{rowData.name}}</td>
                <td>{{rowData.status}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-sidebar>

<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
